var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"text-center",attrs:{"fluid":""}},[(!_vm.$store.getters.isAuthenticated)?_c('login-box'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }